import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import FormHiddenField from "./FormHiddenField";
import IconAutocomplete, { stringOptionsWithIcon } from "./IconAutocomplete";
import { listLocales, listTimeZones } from "../../lib/datetime/displayDateTime";

const TIME_ZONES = stringOptionsWithIcon(listTimeZones(), "schedule");
const LOCALES = stringOptionsWithIcon(listLocales(), "language");

const limitOptions = (options: typeof TIME_ZONES, query: string, limit = 50) => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) {
    return options.slice(0, limit);
  }
  return options.filter((option) => option.label.toLowerCase().includes(normalized)).slice(0, limit);
};

type LocalizationFieldsProps = {
  timeZone: string;
  locale: string;
  onTimeZoneChange: (value: string) => void;
  onLocaleChange: (value: string) => void;
  timeZoneName?: string;
  localeName?: string;
};

const LocalizationFields = ({
  timeZone,
  locale,
  onTimeZoneChange,
  onLocaleChange,
  timeZoneName = "timeZone",
  localeName = "locale",
}: LocalizationFieldsProps) => {
  const { t } = useTranslation();
  return (
  <>
    <Grid size={6}>
      <IconAutocomplete
        options={TIME_ZONES}
        value={timeZone || null}
        onChange={(value) => onTimeZoneChange(value || "")}
        required
        label={t("common.timeZone")}
        filterOptions={(options, state) => limitOptions(options, state.inputValue)}
      />
      <FormHiddenField name={timeZoneName} value={timeZone} />
    </Grid>
    <Grid size={6}>
      <IconAutocomplete
        options={LOCALES}
        value={locale || null}
        onChange={(value) => onLocaleChange(value || "")}
        required
        label={t("common.locale")}
        helperText={t("common.localeHint")}
        filterOptions={(options, state) => limitOptions(options, state.inputValue)}
      />
      <FormHiddenField name={localeName} value={locale} />
    </Grid>
  </>
  );
};

export default LocalizationFields;
